import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'redirect',
  template: 'redirecting...'
})
export class RedirectComponent implements OnInit {
  issubscribe:any=localStorage.getItem('issubscribe')
  constructor(private router: Router) { }

  ngOnInit() {
    if(this.issubscribe === 'false'){
      this.router.navigate(["/userpage"])
    }else{
    window.location.href = 'https://apsblobdeve.blob.core.windows.net/aps-website-files/APSPriceGuide_Member.pdf'
    }
  }
  
}